export const STATUS_SUB_MERCHANT_VERIF = {
  ACTIVE: 6,
  ON_VERIFICATION: 4,
  BLOCKED: 1
};
